import React from 'react';

import {AppButton} from '../../../components/Button';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import welcomePwaDataService from './welcomePwaDataService';
import WelcomePwaTipsItem from './WelcomePwaTipsItem';

const WelcomePwaContent = () => {
    const localizedStrings = getLocalizedStrings();
    const listOfTips = welcomePwaDataService.getTipsData();

    return (
        <div className='flex w-full flex-col items-start justify-center p-8'>
            <h1 className='mb-4 w-full text-start text-24 lg:text-36'>
                {localizedStrings[localizationKeys.WELCOME_PWA_TITLE]}
            </h1>
            <p className='w-full text-start'>{localizedStrings[localizationKeys.WELCOME_PWA_SUB_TITLE]}</p>
            <ul className='my-8 flex w-full flex-col gap-2'>
                {listOfTips.map((item, index) => (
                    <WelcomePwaTipsItem key={index} item={item} />
                ))}
            </ul>
            <AppButton
                className='m-0 h-12 w-full py-3'
                to={welcomePwaDataService.getButtonLink()}
                isExternalLink
                ariaLabel={localizedStrings[localizationKeys.WELCOME_PWA_BTN_ARIA_LABEL]}
                primary
                light
            >
                {localizedStrings[localizationKeys.WELCOME_PWA_BTN]}
            </AppButton>
        </div>
    );
};

export default WelcomePwaContent;
